import React, { Component } from "react";

class FilterButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.bindThis();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.item.selected = !this.props.item.selected;
    this.props.onClick && this.props.onClick(this.props.item);
  }

  render() {
    return (
      <div className={this.props.className}>
        <input
          type="checkbox"
          id={this.props.item.value}
          name={this.props.item.value}
          hidden
          checked={this.props.item.selected}
          onClick={this.onClick}
          readOnly
        />

        <label htmlFor={this.props.item.value}>
          {this.props.item.text}
          {this.props.item.icon === null ? null : <i className={this.props.item.icon}></i>}
        </label>
      </div>
    );
  }
}

export default FilterButton;
